import { Component, OnInit, AfterViewInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Globals } from '../../../globals';
import { OtService } from '../../../providers/ot.service';
import { FormBuilder } from '@angular/forms';
import { GeneralService } from '../../../providers/general.service';

@Component({
  selector: 'app-imprimir',
  templateUrl: './imprimir.component.html',
  styleUrls: ['./imprimir.component.scss']
})
export class ImprimirComponent implements OnInit, AfterViewInit {
  model: any;
  img_header$: any = false;
  form = this._fb.group({
    incluir_observaciones: [true]
  });

  constructor(
    private _dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) private _data,
    public globals: Globals,
    private _fb: FormBuilder,
    private _otSv: OtService,
    private general: GeneralService
  ) { }

  ngOnInit() {
    this.model = this._otSv.imprimirOTformato(this._data.model);
    console.log(this.model);
  }

  ngAfterViewInit() {
    /*this.getBase64('./assets/impresion/cotizacion/' + this.globals.empresa + '/logo.' + this.globals.impresion_header_extension).then((img_url) => {
      this.img_header$ = img_url;
    });*/
    this.img_header$ = this.general.logo_impresion;
  }

  dismiss() {
    this._dialogRef.close();
  }

  getBase64(url: string) {
    return new Promise((resolve, reject) => {
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onload = function () {
        let reader: FileReader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }

  getHTML(): string {
    let printContents = document.getElementById('seccion-para-imprimir').innerHTML;

    return `
      <html>
        <head>
          <meta charset="UTF-8">
		      <meta name="keywords" content="HTML,CSS">
		      <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>` + this.general.nombre_empresa + `</title>
          <style>
            .no-imprimir {
              display: none!important;
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
      </html>`;
  }

  imprimir() {
    let popupWin = window.open('', '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + screen.availWidth + ',height=' + screen.availHeight);
    popupWin.document.open();
    popupWin.document.write(this.getHTML());
    popupWin.document.close();
    this._dialogRef.close();
  }
}
